// import node_modules
import * as PropTypes from 'prop-types';
import * as React from 'react';

// import types
import type { MDXRemoteSerializeResult } from 'next-mdx-remote';
import type { GetStaticProps, NextPage } from 'next';
import {
  ReleaseNoteAppType,
  ReleaseNoteAppTypeEnum,
  ReleaseNoteCategory,
  ReleaseNoteCategoryEnum,
  RouteEnum,
} from '../../types';

// import component
import ReleaseNotesTemplate from '../../components/templates/ReleaseNotesTemplate';

// import modules
import { fetchReleaseNotes } from '../../modules/fetcher';

// define page
const ReleaseNotesPage: NextPage<{
  hrefLang: string;
  releaseNotes: {
    app: ReleaseNoteAppType;
    category: ReleaseNoteCategory;
    content: MDXRemoteSerializeResult;
    ctaLink?: string | null;
    ctaText?: string | null;
    pubDate: string;
    slug: string;
    title: string;
    type: string;
  }[];
}> = ({ hrefLang, releaseNotes }) => (
  <ReleaseNotesTemplate hrefLang={hrefLang} releaseNotes={releaseNotes} />
);

ReleaseNotesPage.propTypes = {
  hrefLang: PropTypes.string.isRequired,
  releaseNotes: PropTypes.arrayOf(
    PropTypes.shape({
      app: PropTypes.oneOf(Object.values(ReleaseNoteAppTypeEnum)).isRequired,
      category: PropTypes.oneOf(Object.values(ReleaseNoteCategoryEnum)).isRequired,
      content: PropTypes.shape({ compiledSource: PropTypes.string.isRequired }).isRequired,
      ctaLink: PropTypes.string,
      ctaText: PropTypes.string,
      pubDate: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
};

export const getStaticProps: GetStaticProps = async () => {
  // init vars
  const locale = 'en';
  const hrefLang = RouteEnum.WEBSITE_RELEASE_NOTES_DE;

  // fetch posts
  const releaseNotesLang = await fetchReleaseNotes({
    sort: { key: 'createdAt', direction: 'desc' },
  });
  const releaseNotes = releaseNotesLang
    ?.filter((item) => item.locale === locale)
    .map((item) => item.releaseNote);

  return { props: { hrefLang, releaseNotes } };
};

export default ReleaseNotesPage;
